<template>
    <v-app id="inspire">
        <v-content class="login-frame">
            <v-container
              class="fill-height "
              fluid
            >
                <v-row
                  align="center"
                  justify="center"
                >
                    <v-col
                      cols="12"
                      sm="8"
                      md="4"
                    >
                        <v-alert
                          type="success"
                          v-if="successActivation"
                        >
                            {{ msg }}. <br>
                        </v-alert>
                        <v-btn
                          v-if="successActivation"
                          block
                          @click="()=> {this.$router.push({name: 'login'})}"
                        >
                            Ir al inicio.
                        </v-btn>
                        <v-alert
                          v-if="!isError && !successActivation"
                          type="info">
                            Activando cuenta...
                        </v-alert>
                        <v-alert
                          v-if="isError"
                          type="error">
                            Ha ocurrido un problema, por favor, reintente más tarde.
                        </v-alert>
                    </v-col>
                </v-row>
            </v-container>
        </v-content>
    </v-app>
</template>

<script>
    import {mapActions} from "vuex";

    export default {
        props: {
            source: String,
        },
        data () {
            return {
                isError: false,
                successActivation: false,
                msg: ''
            }
        },
        mounted() {
            let token = this.getUrlParam('token', '');
            let data = { token};
            this.tokenVerify(data).then(res => {
                this.successActivation = true;
                this.msg = res['message']
            }).catch(() => {
                this.isError = true
            })
        },
        methods: {
            ...mapActions('auth', {
                tokenVerify: 'tokenVerify'
            }),
            getUrlVars() {
                let vars = {};
                window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
                    vars[key] = value;
                });
                return vars;
            },
            getUrlParam(parameter, defaultValue){
                let urlParameter = defaultValue;
                if (window.location.href.indexOf(parameter) > -1) {
                    urlParameter = this.getUrlVars()[parameter];
                }
                return urlParameter;
            }
        }
    }
</script>
<style lang="scss" scoped>
    .login-frame{
        background-image: url('../../assets/img/backgrounds/fondoazul.png');
        background-position: center center;
        background-size: cover;
    }
</style>
